<template>
  <div id="app">
    <component :is="layout">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>
import * as tools from '@/assets/js/tools.js';

export default {
  name: "App",
  data() {
    return {
      layout: null,
    };
  },
  updated() {
		tools.imgToSvg()
    // debugger
	},
  watch: {
    $route(to) {
      if (to.meta.layout !== undefined) {
        this.layout = to.meta.layout + "-layout"
      } else {
        this.layout = "default" + "-layout"
      } 
    },
  }
};
</script>

<style lang="scss">
@import "assets/sass/style";
</style>
